<template>
  <div class="new-user-list">
    <div class="search-bar">
			<b-form-input v-model="text" placeholder="検索キーワード"></b-form-input>
			:Search
    </div>
    <b-table small :current-page="currentPage"
      :per-page="perPage" :fields="fields" :items="items" responsive="sm" class="new-user-table">
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(created_at)="data">
        {{ data.value | formatDateTime }}
      </template>
      <template v-slot:cell(detail)>
        <router-link class="detail" :to="{ name: 'sitter_detail', params: { id: data.item.reported.id }}" exact>詳細</router-link>
      </template>
    </b-table>
    <b-row class="pagination-bar">
      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import apiClient from '../../backend'

export default {
  methods: {
  },
  data () {
    return {
      text: '',
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      fields: [
        {key: 'index', sortable: true, class: 'number'},
        {key: 'user', label: 'User', sortable: true},
        {key: 'content', label: '内容', sortable: true},
        {key: 'created_at', label: '日時', sortable: true},
        {key: 'detail', label: '詳細'},
      ],
      items: []
    }
  },
  components: {
  },
  mounted () {
    apiClient.getReports({
      role: 2
    }).then(response => {
      this.items = response
      this.totalRows = this.items.length
    })
  },
  methods: {
  },
}
</script>
